/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select } from 'antd';
import React from 'react';
import './style.scss';

interface IOptions {
    id: string;
    value: string;
}

interface IProps {
    className?: string;
    placeholder?: string;
    defaultValue?: string | number;
    options?: IOptions[];
    disabled?: boolean;
    loading?: boolean;
    onChange?: (e: any) => void;
    onKeyDown?: (e: KeyboardEvent) => void;
    width?: number;
    height?: number;
    field?: any;
    size?: 'large' | 'default' | 'small';
    id?: string;
}

const SelectWrap: React.FC<IProps> = ({
    className,
    placeholder,
    defaultValue,
    options,
    disabled,
    loading,
    width,
    height,
    onChange,
    field,
    size,
    onKeyDown,
    id,
}) => {
    const getPopupContainer = (trigger: any) => {
        // if (!isModal) {
        //     return document.querySelector('.l-main__content');
        // }
        return trigger.parentElement;
    };
    return (
        <Select
            className={`${className}`}
            style={{ height: height, width: width }}
            placeholder={placeholder}
            defaultValue={defaultValue}
            disabled={disabled}
            loading={loading}
            onChange={onChange}
            size={size || 'middle'}
            getPopupContainer={getPopupContainer}
            onKeyDown={onKeyDown}
            id={id}
            {...field}
        >
            {options?.map((item: IOptions, key: number) => (
                <Select.Option key={key} value={item.id}>
                    {item.value}
                </Select.Option>
            ))}
        </Select>
    );
};

export default React.memo(SelectWrap);
